const PayWithCamsolIcon = ({ width = 200, height = 40 }: { width?: number; height?: number }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 200 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {/* Icon square */}
      <rect width='40' height='40' rx='10' fill='#007DFB' />

      {/* Book icon */}
      <path
        d='M20 28.9288C18.9734 28.9288 18.9647 28.1819 18.0802 27.5447C16.5417 26.4363 14.1768 25.132 12.2939 24.8766C11.9563 24.8392 11.6446 24.6782 11.4188 24.4245C11.1931 24.1708 11.0693 23.8425 11.0713 23.5029V12.4451C11.0713 12.2467 11.1143 12.0507 11.1973 11.8704C11.2803 11.6902 11.4013 11.5301 11.5521 11.4012C11.7002 11.2745 11.8736 11.1809 12.0607 11.1264C12.2478 11.0719 12.4443 11.0579 12.6373 11.0852C15.4729 11.5558 18.0669 12.969 20 15.0963V28.9288Z'
        fill='#007DFB'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20 28.9288C21.0266 28.9288 21.0353 28.1819 21.9198 27.5447C23.4583 26.4363 25.8232 25.132 27.7061 24.8766C28.0437 24.8392 28.3554 24.6782 28.5812 24.4245C28.8069 24.1708 28.9307 23.8425 28.9287 23.5029V12.4451C28.9287 12.2467 28.8857 12.0507 28.8027 11.8704C28.7197 11.6902 28.5987 11.5301 28.4479 11.4012C28.2998 11.2745 28.1264 11.1809 27.9393 11.1264C27.7522 11.0719 27.5557 11.0579 27.3627 11.0852C24.5271 11.5558 21.9331 12.969 20 15.0963V28.9288Z'
        fill='white'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      {/* "paywith" text in gray */}
      <text
        x='48'
        y='20'
        fontFamily='Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
        fontSize='14'
        fontWeight='500'
        fill='#666666'
      >
        paywith
      </text>

      {/* "CAMSOL" text in blue */}
      <text
        x='100'
        y='20'
        fontFamily='Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
        fontSize='14'
        fontWeight='700'
        fill='#007DFB'
      >
        CAMSOL
      </text>
    </svg>
  )
}

export default PayWithCamsolIcon
